// True when a WebAuthn ceremony was aborted/declined by the user (cancelled
// the browser/OS prompt) rather than failing for a real error, so callers can
// show a softer "cancelled" message instead of a generic failure.
export const isPasskeyCancellation = (error: unknown): boolean => {
  const err = error as {
    name?: string;
    code?: string;
    cause?: { name?: string };
  };

  return (
    err?.name === "NotAllowedError" ||
    err?.name === "AbortError" ||
    err?.cause?.name === "NotAllowedError" ||
    err?.cause?.name === "AbortError" ||
    err?.code === "ERROR_CEREMONY_ABORTED"
  );
};
